"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NiftoryProvider = exports.NiftoryContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const urql_1 = require("urql");
exports.NiftoryContext = (0, react_1.createContext)(null);
const NiftoryProvider = ({ children, client, }) => {
    const urqlClient = (0, react_1.useMemo)(() => client === null || client === void 0 ? void 0 : client.getGraphqlClient(), [client]);
    return (react_1.default.createElement(exports.NiftoryContext.Provider, { value: { client: client } },
        react_1.default.createElement(urql_1.Provider, { value: urqlClient }, children)));
};
exports.NiftoryProvider = NiftoryProvider;
